export default function PolicyCostData() {
    return {
        text: {
            title: "How much will your policy cost",
            paragraphs: ["There are several factors that determine your price for coverage. In addition to amount and term, the insurance companies will review your age, gender, health as well as financial and lifestyle background to evaluate your risk classification which drives your final price.", "Our licensed, non-commissioned experts have your best interests in mind and will help you secure the right provider company and coverage to fit in your budget."],
        },
        image: "/product-landing/term/policy-cost.jpg",
        callToActionText: "SEE YOUR QUOTES",
    };
}
